import {defineRecipe} from '@chakra-ui/react3'

const moduleContainerRecipe = defineRecipe({
    base: {
        // mark this as inline size container to allows children
        // to use container queries and dimension
        // useful to span full visible width without causing horizontal overflow
        containerType: 'inline-size',
        paddingX: 'var(--container-inline-padding)',
        '--container-inline-padding': {
            base: 'spacing.container-padding-mobile',
            s: 'spacing.container-padding-desktop'
        },
        // use child selector to compute variables on the child container which applies the maxWidth
        '& > *': {
            // compute the applied padding and extra margin from the applied max-width from layerStyle
            // note: this could be simplified to `100cqw-50%`, but that depends on the property where it is used
            // and for scroll-padding it doesn't compute correctly as the percentage is from the scroll container
            '--container-total-inline-padding':
                'calc(var(--container-inline-padding, 0px) + max(0px, 50cqw - var(--max-container-width, 100cqw) * 0.5))'
        }
    },
    variants: {
        modulePadding: {
            default: {
                '--container-inline-padding': {
                    base: 'spacing.container-padding-mobile',
                    s: 'spacing.container-padding-desktop'
                }
            },
            none: {
                '--container-inline-padding': 'spacing.spacing-0'
            },
            awards: {
                // mobile: default padding, desktop: fullwidth
                '--container-inline-padding': {s: 'spacing.spacing-0'}
            },
            highlightStack: {
                '--container-inline-padding': 'spacing.spacing-0'
            },
            hero: {
                // module fullwidth
                '--container-inline-padding': 'spacing.spacing-0'
            },
            media: {
                // module fullwidth
                '--container-inline-padding': 'spacing.spacing-0'
            },
            productColors: {
                // mobile, desktop: fullwidth
                '--container-inline-padding': 'spacing.spacing-0'
            },
            collage: {
                '--container-inline-padding': 'spacing.spacing-0'
            },
            usp: {
                '--container-inline-padding': 'spacing.spacing-0'
            }
        },
        background: {
            default: {
                '--module-surface-bg-color': 'colors.background.surface.on-section-default',
                '--module-bg-color': 'colors.background.section.default',
                backgroundColor: 'background.section.default'
            },
            subtle: {
                '--module-surface-bg-color': 'colors.background.surface.on-section-subtle',
                '--module-bg-color': 'colors.background.section.subtle',
                backgroundColor: 'background.section.subtle'
            },
            strong: {
                '--module-surface-bg-color': 'colors.background.surface.on-section-strong',
                '--module-bg-color': 'colors.background.section.strong',
                backgroundColor: 'background.section.strong'
            },
            inverse: {
                '--module-surface-bg-color': 'colors.background.surface.on-section-inverted',
                '--module-bg-color': 'colors.background.section.strong',
                backgroundColor: 'background.section.strong'
            },
            none: {
                // no background color - not currently defined for modules that need the --module-* css vars
            }
        },
        spacing: {
            default: {
                paddingTop: {base: 'spacing-64', s: 'spacing-128'},
                paddingBottom: {base: 'spacing-40', s: 'spacing-128'}
            },
            reduced: {
                paddingTop: 'spacing-40',
                paddingBottom: 'spacing-40'
            },
            min: {
                paddingTop: 'spacing-20',
                paddingBottom: 'spacing-20'
            },
            'min-top': {
                paddingTop: 'spacing-20',
                paddingBottom: {base: 'spacing-40', s: 'spacing-128'}
            },
            'min-bottom': {
                paddingTop: {base: 'spacing-64', s: 'spacing-128'},
                paddingBottom: 'spacing-20'
            },
            none: {
                paddingY: 'spacing-0'
            }
        }
    },
    defaultVariants: {
        background: 'default',
        modulePadding: 'default',
        spacing: 'default'
    }
})

export default moduleContainerRecipe
